import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { MailCheck, LogOut } from "lucide-react";

export default function EmailVerifyGate() {
  const { user, logout, refresh } = useAuth();
  const [busy, setBusy] = useState(false);

  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Verification email sent. Check your inbox.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed to send email");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-charcoal/70 backdrop-blur-sm flex items-start md:items-center justify-center p-4 overflow-y-auto" data-testid="verify-gate">
      <div className="bg-bone rounded-2xl max-w-lg w-full my-8 shadow-2xl p-10">
        <div className="w-14 h-14 mx-auto mb-6 bg-oxblood/10 rounded-full flex items-center justify-center">
          <MailCheck size={26} strokeWidth={1.75} className="text-oxblood"/>
        </div>
        <p className="text-[13px] uppercase tracking-[0.22em] text-stone mb-2 text-center">Required · One-time</p>
        <h2 className="font-serif text-3xl md:text-4xl tracking-tight mb-4 text-center">Verify your email.</h2>
        <p className="text-sm text-stone mb-8 text-center leading-relaxed">
          We sent a verification link to<br/>
          <span className="font-mono text-charcoal" data-testid="verify-gate-email">{user?.email}</span><br/><br/>
          Click the link in that email to unlock the catalog. If you don't see it, check your spam folder or resend below.
        </p>
        <div className="space-y-3">
          <button
            onClick={resend}
            disabled={busy}
            className="w-full py-3.5 bg-charcoal text-bone tracking-[0.22em] text-xs uppercase hover:bg-oxblood transition-colors rounded-full disabled:opacity-50"
            data-testid="resend-verification-btn"
          >
            {busy ? "Sending…" : "Resend verification email"}
          </button>
          <button
            onClick={refresh}
            className="w-full py-3 border border-borderSubtle text-[13px] tracking-[0.22em] uppercase text-charcoal hover:border-charcoal transition-colors rounded-full"
            data-testid="verify-refresh-btn"
          >
            I've verified — refresh
          </button>
          <button
            onClick={logout}
            className="w-full py-2 text-[13px] tracking-[0.22em] uppercase text-stone hover:text-oxblood transition-colors inline-flex items-center justify-center gap-2"
          >
            <LogOut size={12}/> Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
